<template>
  <v-container fluid>
    <FilterOrder
      @setFilter="setFilter"
    />
    <v-sheet
      min-height="200"
      class="w-100 d-flex align-center justify-center"
      v-if="orderList.length === 0"
    >
      <v-progress-circular
        v-if="isLoading"
        indeterminate
        color="primary"
        class="w-100 mt-10 mb-10"
      ></v-progress-circular>
      <h2 v-if="!isLoading">{{$_strings.common.NO_DATA}}</h2>
    </v-sheet>
    <section v-else class="my-4">
      <v-card
        hover
        :to="`/main/status-pesanan/detail/${item.id}?status=FINISH&title=${item.title}&latestStatus=${item.latestStatus}&serviceType=${item.serviceType}&pickupDateFrom=${dateFilterFormat(filter.pickupDateFrom)}&pickupDateTo=${dateFilterFormat(filter.pickupDateTo)}`"
        @click="viewDetail(item.id, item.title, item.latestStatus, item.serviceType)"
        v-for="(item) in orderList"
        v-bind:key="item.id"
        class="mb-5"
      >
        <v-card-title>
          <v-row justify="space-between">
            <v-col>
              <v-icon class="body-2 ml-2 mr-3">mdi-archive</v-icon>
              <span class="body-2">{{item.title}}</span>
            </v-col>
            <v-col cols="auto">
              <v-btn
                :color="getColorButtonStatus(item.latestStatus)"
                dark
                small
              >
                {{item.latestStatus}}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="d-flex align-center" cols="auto">
              <v-icon color="light-blue lighten-2">
                mdi-map-marker
              </v-icon>
              <p class="mb-0 black--text pl-3">
                {{item.originLocationName}} <br />
                <span class="grey--text text--darken-1">{{item.originCityName}} </span>
              </p>
            </v-col>
          </v-row>
          <v-row v-if="getShipmentDetail(item.shipmentsDetail, 'MULTIPICK').length > 0">
            <v-col cols="auto">
              <v-row>
                <v-col class="pt-0" cols="auto">
                  <v-icon color="green">
                    mdi-map-marker
                  </v-icon>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col v-for="(multipick, indexMultipick) in getShipmentDetail(item.shipmentsDetail, 'MULTIPICK')" :key="indexMultipick" class="d-flex align-center pa-0" cols="10">
                  <p class="mb-0 black--text">
                    Pick {{indexMultipick + 1}} - {{multipick.locationName}} <br />
                    <span class="grey--text text--darken-1">{{multipick.cityName}}</span>
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="mx-4 mt-4"></v-divider>
          <v-row class="pl-5 mt-2" v-if="getShipmentDetail(item.shipmentsDetail, 'MULTIDROP').length > 0">
            <v-col cols="auto">
              <v-row>
                <v-col class="pt-0" cols="auto">
                  <v-icon color="red accent-4">
                    mdi-map-marker
                  </v-icon>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col v-for="(multidrop, indexMultidrop) in getShipmentDetail(item.shipmentsDetail, 'MULTIDROP')" :key="indexMultidrop" class="d-flex align-center pa-0" cols="10">
                  <p :class="getShipmentDetail(item.shipmentsDetail, 'MULTIDROP').length - 1 === indexMultidrop ? 'mb-2': 'mb-0' " class="black--text">
                    Drop {{indexMultidrop + 1}} - {{multidrop.locationName}} <br />
                    <span class="grey--text text--darken-1">{{multidrop.cityName}}</span>
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div v-else class="mt-2"></div>
          <v-row class="pl-5 mt-1">
            <v-col class="d-flex align-center pt-0" cols="auto">
              <v-icon color="yellow accent-4">
                mdi-map-marker
              </v-icon>
              <p class="black--text mb-0 pl-3">
                {{item.destinationLocationName}} <br />
                <span class="grey--text text--darken-1">{{item.destinationCityName}} </span>
              </p>
            </v-col>
          </v-row>
          <Backhauling
            v-if="item.backhauling"
            :item="item.backhauling"
          />
          <v-row>
            <v-col class="d-flex pb-0 pt-0 justify-end">
              <p class="grey--text">{{dateFormat(item.pickupDate)}}</p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card v-intersect="infiniteScrolling"></v-card>
      <v-progress-circular
        v-if="isLoading"
        indeterminate
        color="primary"
        class="w-100 mt-10 mb-10"
      ></v-progress-circular>
      <div v-if="totalData === orderList.length" class="w-100 pa-5 d-flex justify-center">
        <span class="caption grey--text font-weight-bold">{{$_strings.statusOrder.END_OF_ORDER}}</span>
      </div>
    </section>
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import axios from 'axios';
import { dateFormat, dateFilterFormat } from '../../../helper/commonHelpers';
import FilterOrder from '../FilterOrder.vue';

const { CancelToken } = axios;
let source = CancelToken.source();

export default {
  components: {
    FilterOrder,
  },
  created() {
    source = CancelToken.source();
    this.fetchData();
  },
  beforeDestroy() {
    source.cancel('CANCELED_BY_THE_USER');
  },
  data() {
    const { fromDate, toDate, search } = this.$route.query;
    const currentDate = dayjs().add('7', 'days').format('YYYY-MM-DD');
    return {
      orderList: [],
      totalData: 0,
      isLoading: false,
      filter: {
        sort: 'pickupDate,DESC',
        pickupDateFrom: fromDate || dayjs(currentDate).subtract('7', 'days').format('YYYY-MM-DD'),
        pickupDateTo: toDate || currentDate,
        title: search || '',
        page: 0,
        size: 10,
      },
    };
  },
  watch: {
    '$route.path': function setQuery() {
      const { tab } = this.$route.params;
      const { query } = this.$route;
      const { pickupDateFrom, pickupDateTo, title } = this.filter;
      if (tab === 'completed' && !Object.keys(query).length) {
        this.$router.replace({
          name: this.$route.name,
          query: {
            fromDate: pickupDateFrom,
            toDate: pickupDateTo,
            search: title,
          },
        });
      }
    },
  },
  methods: {
    dayjs,
    dateFormat,
    dateFilterFormat,
    async fetchData() {
      const status = 'FINISH';
      try {
        this.isLoading = true;
        const result = await this.$_services.order.getStatusOrder(this.filter, status, source);
        result.data.contents.forEach((data) => {
          this.orderList.push(data);
        });
        this.totalData = result.data.totalData;
      } finally {
        this.isLoading = false;
      }
    },
    setFilter(filterBy, value) {
      this.filter[filterBy] = value;
      this.orderList = [];
      this.filter.page = 0;
      this.fetchData();
    },
    viewDetail(orderId, title, latestStatus, serviceType) {
      const { pickupDateFrom, pickupDateTo } = this.filter;
      this.$router.push({
        name: 'order-status-detail',
        params: {
          id: orderId,
        },
        query: {
          status: 'FINISH',
          title,
          latestStatus,
          serviceType,
          pickupDateTo,
          pickupDateFrom,
        },
      });
    },
    getShipmentDetail(shipmentDetail, multiType) {
      const data = [];
      if (shipmentDetail) {
        shipmentDetail.forEach((e) => {
          if (e.multiType === multiType) {
            data.push(e);
          }
        });
      }
      return data;
    },
    getListInfiniteScroll() {
      if (!this.isLoading && this.orderList.length < this.totalData) {
        this.filter.page += 1;
        this.fetchData();
      }
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting && !this.isLoading) {
        this.getListInfiniteScroll();
      }
    },
    getColorButtonStatus(status) {
      switch (status.toLowerCase()) {
        case 'ditolak':
        case 'kedaluwarsa':
        case 'dibatalkan':
          return 'red lighten-1';
        case 'barang diterima tidak utuh':
          return 'red lighten-2';
        default: return 'green';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-badge {
  span {
    color: black !important;
    font-weight: bold;
  }
}
v-card:hover {
  background: red;
  display: block;
  width: 200px;
  position: relative;
  height: 200px;
}
</style>
